<template lang="pug">
li.item-link
  router-link.parent(:to="href" v-if="href !== undefined && href !== '' " :class="[menuChilds !== undefined && menuChilds !== null && this.$route.meta.parentName !== undefined && menuChilds.includes(this.$route.meta.parentName) ? 'active' : '']")
    .icon-header(v-bind:class="[(avatar == undefined || (avatar !== undefined && avatar === '')) && (icon === undefined || icon === '')? 'remove-img': '']")
      .avt-sidebar(v-if="avatar !== undefined && avatar !== ''")
        img(:src="avatar")
      .material-icons.text-gray(v-else-if="(avatar === undefined || !avatar) && !isAwesome(icon)") {{icon}}
      .fontawesome.text-gray(v-else)
        i(v-bind:class="[icon != '' ? icon : '']")
    .text-header(v-bind:class="[(avatar == undefined || (avatar !== undefined && avatar === '')) && (icon === undefined || icon === '')? 'full-text': '']")
      span {{title}}
  router-link.parent(href="javascript:;" v-else)
</template>

<script>
export default {
  props: {
    icon: String,
    title: String,
    href: String,
    avatar: String,
    menuChilds: Array
  },
  methods: {
    isAwesome: function(text) {
      if (text !== undefined && text) {
        return text.indexOf('fa-') !== -1
      }
      return false
    }
  }
}
</script>




// WEBPACK FOOTER //
// item.vue?d6b1e52a